import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SignUpRoutingModule } from './sign-up-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SignUpRoutingModule
  ]
})
export class SignUpModule { }
/**
 * Modal for Sign Up  Request
 */
export class MSignUpRequest{
  phone_number!: number;
  first_name!:  string;
  last_name!:  string;
  email?: string;
  gender?: number;
  birth_date?: Date;
  type_id!: number;
  alternate_mob_no?: number;
  role_permissions_id!: string;
  password!: string;
}
/**
 * Modal for Update user  Request
 */
export class MUpdateUserRequest{
  id!:string
  first_name!:  string;
  last_name!:  string;
  email?: string;
  gender?: string;
  birth_date?: Date;
  alternate_mob_no?: number;
  
}
/**
 * Modal for Sign Up  Response
 */
export class MSignUpResponse {
  statusCode!: number;
  message!: string;
  totalRecords!: number;
  data!: [MSignUpResponseData];
  token!: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
/**
 * Modal for Sign Up  Response Data 
 */
export class MSignUpResponseData {
  phone_number!: number;
  first_name!:  string;
  last_name!:  string;
  email?: string;
  gender?: number;
  birth_date?: Date;
  type_id!: number;
  alternate_mob_no?: number;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
